
import React from 'react';
import { Button } from "@/components/ui/button";
import { RotateCw } from "lucide-react";

interface CompanyInsightsProps {
  insights: string | null;
  onRegenerate: () => void;
}

const CompanyInsights = ({ insights, onRegenerate }: CompanyInsightsProps) => {
  // Format insights to remove any potential title lines
  const formattedInsights = insights?.trim();

  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <p className="text-sm font-medium text-gray-500">Company Insights</p>
        <Button 
          variant="ghost" 
          size="sm"
          onClick={onRegenerate}
          className="h-8 px-2"
        >
          <RotateCw className="h-4 w-4" />
        </Button>
      </div>
      <div className="p-4 bg-gray-50 rounded-lg">
        {formattedInsights ? (
          <p className="text-sm text-gray-600">{formattedInsights}</p>
        ) : (
          <p className="text-sm text-gray-600">
            Generating insights...
          </p>
        )}
        <p className="text-xs text-gray-400 mt-2">
          Last updated: {new Date().toLocaleDateString()}
        </p>
      </div>
    </div>
  );
};

export default CompanyInsights;
